import { getVideoOptions } from './config';

export async function checkRecordingExists(videoId: string | { IdValue: string }): Promise<boolean> {
  if (!videoId) {
    return false;
  }

  videoId = typeof videoId === 'string' ? videoId : videoId.IdValue;
  const url = `${getVideoOptions().VIDEO_RECORDINGS_ROOT_URL}/${videoId}/playlist.m3u8`;

  try {
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok;
  } catch {
    return false;
  }
}
